import script from "./PostalCodeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PostalCodeInput.vue?vue&type=script&setup=true&lang=js"

import "./PostalCodeInput.vue?vue&type=style&index=0&id=3a1f8d1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1f8d1b"]])

export default __exports__